
const passwordRegular = /^(?:\d+|[a-zA-Z]+|[!@#$%^&*]+)$/;

const basic_url = 'http://scmapi.sporax.net/';
// const basic_url = 'http://scmapi.sporax.net.test/';


export default {
    passwordRegular,
    basic_url
}